import { render, staticRenderFns } from "./ChatsShipmentsTable.vue?vue&type=template&id=6dea6a18&scoped=true&"
import script from "./ChatsShipmentsTable.vue?vue&type=script&lang=js&"
export * from "./ChatsShipmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ChatsShipmentsTable.vue?vue&type=style&index=0&id=6dea6a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea6a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBadge,VDataTable,VPagination,VSelect,VTextField})
